import EquationInput from "../../../../components/inputs/EquationInput";
import { BlockMath, InlineMath } from "react-katex";
import { checkCircleEquation } from "../../../../utils/circleEquation";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import { CIRCLE_GRAPH_COLORS, getCircleGraphRanges } from "../../../../components/GraphPlotter/circleGraphRanges";

function simplifySqrt(n) {
  let a = 1;
  let b = n;
  for (let i = 2; i * i <= n; i++) {
    while (b % (i * i) === 0) {
      b = b / (i * i);
      a = a * i;
    }
  }
  if (b === 1) return `${a}`;
  if (a === 1) return `\\sqrt{${b}}`;
  return `${a}\\sqrt{${b}}`;
}

const RADICAL_RADIUS_SQUARED_VALUES = Array.from({ length: 24 }, (_, index) => index + 2)
  .filter((value) => !Number.isInteger(Math.sqrt(value)));

function formatShifted(variable, value) {
  if (value === 0) return `${variable}^2`;
  if (value > 0) return `(${variable} - ${value})^2`;
  return `(${variable} + ${Math.abs(value)})^2`;
}

export function generateTask() {
  const getRandomInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const x = getRandomInt(-3, 3);
  const y = getRandomInt(-3, 3);
  const usesRadicalRadius = Math.random() < 0.2;
  const integerRadius = usesRadicalRadius ? null : getRandomInt(1, 13);
  const r2 = usesRadicalRadius
    ? RADICAL_RADIUS_SQUARED_VALUES[getRandomInt(0, RADICAL_RADIUS_SQUARED_VALUES.length - 1)]
    : integerRadius ** 2;

  const rSimplified = simplifySqrt(r2);

  const left = `${formatShifted("x", x)} + ${formatShifted("y", y)}`;
  const answerLatex = `${left} = ${r2}`;

  return {
    type: "WriteCircleEquationTask",
    data: {
      center: { x, y },
      rSquared: r2,
      rSimplified,
      numericRadius: Math.sqrt(r2),
      radiusKind: usesRadicalRadius ? "radical" : "integer",
    },
    answer: answerLatex,
  };
}



export function renderTask(task) {
  const { center, rSimplified } = task.data;
  const { x, y } = center;

  return (
    <div>
      Napisz równanie okręgu o środku{" "}
      <InlineMath math={`S = (${x},\\ ${y})`} /> i promieniu{" "}
      <InlineMath math={`r = ${rSimplified}`} />.
    </div>
  );
}




export function renderInput(task, userInput, setUserInput, disabled) {
  return (
    <EquationInput
      value={userInput}
      onChange={setUserInput}
      disabled={disabled}
      placeholder="(x - a)^2 + (y - b)^2 = r^2"
    />
  );
}


export function checkAnswer(task, userInput) {
  return checkCircleEquation(userInput, task.answer);
}

export function renderAnswer(task) {
  return (
    <InlineMath math={task.answer} />
  );
}



export function renderUserAnswer(userAnswer) {
  if (!userAnswer || userAnswer.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={userAnswer} />;
}




// surowe podstawienie z nawiasem: np. (x - (-4))^2
function formatShiftedRaw(variable, value) {
  return `(${variable} - (${value}))^2`;
}

function formatShiftedLatex(variable, value) {
  if (value === 0) return `${variable}^2`;
  if (value > 0) return `(${variable} - ${value})^2`;
  return `(${variable} + ${Math.abs(value)})^2`;
}

export function renderExplanation(task) {
  const { center, rSquared, rSimplified, numericRadius } = task.data;
  const { x, y } = center;
  const { xRange, yRange, graphSize } = getCircleGraphRanges({
    circles: [{ center, radius: numericRadius }],
    points: [center],
  });

  return (
    <div className="space-y-4" style={{ textAlign: "left" }}>
      <div>
        Równanie okręgu o środku <InlineMath math={`S = (${x},\\ ${y})`} /> i promieniu{" "}
        <InlineMath math={`r = ${rSimplified}`} /> podstawiamy do wzoru
        kanonicznego:
        <BlockMath math="(x - a)^2 + (y - b)^2 = r^2" />
        <div className="mt-2">
          Po podstawieniu:
          <BlockMath
            math={`${formatShiftedLatex("x", x)} + ${formatShiftedLatex("y", y)} = ${rSquared}`}
          />
        </div>
      </div>

      <div>
        <strong>Wizualizacja:</strong>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <GraphViewer
            circles={[
              {
                center: { x, y },
                radius: numericRadius,
                color: CIRCLE_GRAPH_COLORS.circle,
                label: "okrąg",
              },
            ]}
            points={{ S: { x, y, color: CIRCLE_GRAPH_COLORS.point, textColor: CIRCLE_GRAPH_COLORS.point } }}
            xRange={xRange}
            yRange={yRange}
            width={graphSize}
            height={graphSize}
            showGrid
          />
        </div>
      </div>
    </div>
  );
}


